import { DEFAULT_ERROR_MODAL_TITLE, REGISTRATION_MESSAGE_TYPES } from '@buxus/shared'
import { postNativeHostMessage, hasNativeHostBridge } from '../shell/nativeHostBridge'

export type AppErrorModalRequest = {
  title: string
  message: string
  messageNode?: import('react').ReactNode
}

type Listener = (req: AppErrorModalRequest | null) => void
const listeners = new Set<Listener>()

function emit(req: AppErrorModalRequest | null): void {
  for (const listener of listeners) listener(req)
}

export function subscribeAppErrorModal(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export type ShowAppErrorModalOptions = {
  title?: string
  message: string
  messageNode?: import('react').ReactNode
}

/**
 * Present a blocking user-facing error. Uses the native shell modal when embedded in
 * React Native WebView; otherwise shows the in-app modal via `ErrorModalProvider`.
 */
export function showAppErrorModal(opts: ShowAppErrorModalOptions): void {
  const title = opts.title?.trim() || DEFAULT_ERROR_MODAL_TITLE
  const message = opts.message.trim()
  if (!message) return

  if (hasNativeHostBridge()) {
    postNativeHostMessage({
      type: REGISTRATION_MESSAGE_TYPES.DISPLAY_ERROR_MODAL,
      payload: { title, content: message },
    })
    return
  }

  emit({ title, message, messageNode: opts.messageNode })
}

export function dismissAppErrorModal(): void {
  emit(null)
}
